<script>
    import f9link from "inputs/f9link.vue";
    import limitedTimeOffer from "forms/LimitedTimeOffer.vue"
    import { get, postForm, getIbeHost, getCDNHost } from "shared/Utilities/fetchUtilities";

    export default {

        props: {
            inSlider: {
                type: Boolean,
                default: false
            },
            discountAmount:{
                type:String,
                default:""
            },
            enrollmentFeeAmount:{
                type:String,
                default:""
            },
            signupFeeAmount:{
                type:String,
                default:""
            },
            totalAmount:{
                type:String,
                default:""
            },
            discountedEnrollmentFeeAmount:{
                type:String,
                default:""
            }
        },
        computed: {
            showLimitedTimeOffer(){
              return (this.discountAmount === "$0.00") ? false : true;
            }
        },
        components: {
            f9link,
            limitedTimeOffer
        }
    }
</script>

<template>
    <div class="dd-info-container">
        <div class="dd-top-section" :class="{ 'in-slider': inSlider }" >
            <div class="dd-bear-img-container" :class="{ 'in-slider': inSlider }">
                <img class="dd-bear-img" :class="{ 'in-slider': inSlider }" src="/Content/responsive/images/bear-circle.svg" alt />
                <div class="dd-top-header" :class="{ 'in-slider': inSlider }">DISCOUNT DEN<span class="sm" :class="{ 'in-slider': inSlider }">&reg;</span></div>
            </div>
            <div class="text-container" :class="{ 'in-slider': inSlider }">
                <div class="dd-top-generic" :class="{ 'in-slider': inSlider }">With a DISCOUNT DEN membership you will have exclusive access to Frontier's lowest fares, guaranteed.</div>
                 <div class="dd-top-cost" v-if="this.discountAmount === '$0.00'">Annual membership costs {{signupFeeAmount}} for one full year of savings. New members pay {{totalAmount}} their first year ({{signupFeeAmount}} + {{enrollmentFeeAmount}} enrollment fee).
                     <f9link href="https://www.flyfrontier.com/deals/discount-den/" target="_blank" class="learn-more">Learn More</f9link>
                </div>
                <div class="dd-top-cost" v-else>Annual membership costs {{signupFeeAmount}} for one full year of savings, new members pay an additional enrollment fee.
                     <f9link href="https://www.flyfrontier.com/deals/discount-den/" target="_blank" class="learn-more">Learn More</f9link>
                </div>
            </div>
            <div class="dd-top-sub errorState" :class="{ 'in-slider': inSlider }" v-if="totalAmount === ''">An error has occurred.  Please refresh the page and try again.  If the problem persists please contact our <a href="https://www.flyfrontier.com/chat-with-us/" target="_blank">chat agents</a>.</div>
            <div class="limited-time-offer-container" v-show="showLimitedTimeOffer" :class="{ 'in-slider': inSlider }">
                <limited-Time-Offer :backgroundColor="'#006643'" :color="'#ffffff'" :signupFeeAmount="signupFeeAmount" :enrollmentFeeAmount="enrollmentFeeAmount" :discountedEnrollmentFeeAmount="discountedEnrollmentFeeAmount" :totalAmount="totalAmount"></limited-Time-Offer>        
            </div>
            
        </div>
        <!-- Upsell Images Container -->
        <div class="greyBackground" v-show="!inSlider" :class="{ 'in-slider': inSlider }"></div>
        <div class="dd-benefits-details-container" :class="{ 'in-slider': inSlider }">
                <div class="low-fares-container" :class="{ 'in-slider': inSlider }">
                    <img src="/Content/responsive/images/savings_icon.svg" :class="{ 'in-slider': inSlider }" alt />
                    <span class="heading lowest-fares">Lowest Fare Guaranteed</span>
                    <span class="sub-heading lowest-fares">Exclusive access to the lowest fares</span>
                </div>
                <div class="kff-container" :class="{ 'in-slider': inSlider }">
                    <img src="/Content/responsive/images/backpack phone.svg" :class="{ 'in-slider': inSlider }" alt />
                    <span class="heading kff">Kids Fly Free<span class="sm" :class="{ 'in-slider': inSlider }">&#8480;</span></span>
                    <span class="sub-heading kff">Kids Fly Free on select dates & flights</span>
                </div>
                <div class="exclusive-container" :class="{ 'in-slider': inSlider }">
                    <img src="/Content/responsive/images/phone.svg" :class="{ 'in-slider': inSlider }" alt />
                    <span class="heading exclusive">Exclusive Deals</span>
                    <span class="sub-heading exclusive">Get our lowest fare and exclusive promotions</span>
                </div>
                <div class="share-container" :class="{ 'in-slider': inSlider }">
                    <img src="/Content/responsive/images/suitcases.svg" :class="{ 'in-slider': inSlider }" alt />
                    <span class="heading">Share the Savings</span>
                    <span class="sub-heading">Book DISCOUNT DEN fares for up to 9 people</span>
                </div>
            </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .dd-info-container {

            .sm{
                font-size: 10px;
            }
        
            .dd-top-section{
                display: flex;
                flex-direction: column;
                margin-bottom: 4%;
                .dd-bear-img-container{
                    display: flex;
                    .dd-bear-img{
                        width: 185px;
                        height: 185px;

                        &.in-slider{
                            width: 55px;
                            height: 55px;
                        }
                    }
                    .dd-top-header{
                        color: @frontier-green;
                        font-size: 63px;
                        font-weight: 700;
                        margin-left:2%;

                        .sm{
                            bottom: 37px;
                            font-size: 12px;

                            &.in-slider{
                                bottom:17px;
                            }
                        }
                        &.in-slider{
                            font-size: 36px;
                            align-self: center;
                        }
                    }
                }
                .text-container{
                    flex-direction: column;
                    margin-left: 19%;
                    margin-top: -9%;

                    &.in-slider{
                        margin-left: -2%;
                        margin-top: 0;
                    }
                  
                    .dd-top-generic, .dd-top-cost{
                        margin-top: 10px;
                        color: @ibe-text--dark-gray;
                        font-size: 17px;
                        font-weight: 400;

                        .learn-more{
                            text-decoration: underline;
                        }

                        &.in-slider{
                            font-size: 16px;
                        }
                    }
                }
                .limited-time-offer-container {
                  padding-left: 25%;
                  padding-right: 25%;

                  &.in-slider{
                    padding-left: 10%;
                    padding-right: 10%;
                  }
                }
            }
            .greyBackground{
              position: absolute;
              left: 0;
              width: 100%;
              background-color: #ebebeb;
              height: 283px;
              z-index: -1;
            }
            .dd-benefits-details-container{
                display: flex;
                flex-direction: row;
                padding: 40px 0 40px 0;
                margin: 20px 0 60px 0;
                justify-content: space-around;

                &.in-slider{
                    padding: 0;
                    margin: 0 -6% 6% -6%; 
                    background-color: #ebebeb;
                    padding: 40px 0 40px 0;
                }


              img{
                width: 75px;
                height: 75px;
                align-self: center;
              }

              .low-fares-container,
              .kff-container,
              .exclusive-container,
              .share-container{
                display: flex;
                flex-direction: column;
                width: 15%;
                
                &.in-slider{
                    width: 23%;
                }

                img.in-slider{
                    width: 46px;
                    height: 46px;
                }

                .heading{
                  font-size: 18px;
                  font-weight: 700;
                  margin-top: 13%;
                  text-align: center;
                  line-height: 120%;
                  width: 100%;
                  color: @ibe-text--dark-gray;
                }
                .sub-heading{
                  font-size: 14px;
                  font-weight: 400;
                  text-align: center;
                  margin-top: 3%;
                  line-height: 130%;
                  width: 100%;
                  color: @ibe-text--dark-gray;
                }
              }
            }
    }

    @media @tablet {
        .dd-info-container {


            .dd-top-section{
                margin-bottom: 12%;
                 .dd-bear-img-container{

                     &.in-slider{
                        margin-left: -7%;
                        margin-right: -7%;
                     }
                     
                    .dd-bear-img, .in-slider.dd-bear-img{
                        width: 36px;
                        height: 36px;
                    }
                     .dd-top-header{
                        font-size: 32px;
                        font-weight: 700;

                    &.in-slider{
                        font-size: 28px;
                     }

                        .sm{
                            bottom: 15px;
                            font-size: 12px;

                            &.in-slider{
                                bottom: 12px;
                            }
                        }
                    }
                }

                .text-container{
                    margin-top:0;
                    margin-left:0;

                    &.in-slider{
                        margin-left:-8%;
                        margin-right: -8%;
                        line-height: 120%;
                    }
                   
                    .dd-top-generic, .dd-top-cost{
                        font-size: 14px;

                        &.in-slider{
                            font-size: 14px;
                        }
                    }
                }   
                
                .limited-time-offer-container {
                  margin-left: -7%;
                  margin-right: -7%;
                  padding-left: 0;
                  padding-right: 0;
                  margin-bottom:0;

                  &.in-slider {
                    margin-left: -16%;
                    margin-right: -16%;
                    padding-left: 0;
                    padding-right: 0;                   
                  }
                }
            }

            .dd-benefits-details-container{
              display: flex;
              flex-direction: row;
              padding: 0 0 40px 0;
              margin: 20px 0 20px 0;
              flex-wrap: wrap;

              &.in-slider{
                    display: flex;
                    flex-direction: row;
                    padding: 1% 6% 10% 6%;
                    flex-wrap:wrap;
                    margin-top: 9%;
                    margin-left: -15%;
                    margin-right: -16%;
                    margin-bottom: 9%;
                }

              img{
                width: 38px;
                height: 38px;
                align-self: center;
              }



              .low-fares-container,
              .kff-container,
              .exclusive-container,
              .share-container{
                display: flex;
                flex-direction: column;
                width: 46%;
                margin-top:5%; 

                &.in-slider{
                    width: 50%;
                    margin-top:9%;
                }

                img.in-slider{
                    width: 37px;
                    height: 37px;
                }

                .heading{
                  font-size: 16px;
                  font-weight: 700;
                  margin-top: 4%;
                  text-align: center;
                  line-height: 120%;
                  width: 100%;
                  color: @ibe-text--dark-gray;

                    &.in-slider{
                        font-size: 16px;
                        font-weight: 600;
                        margin-top:2%;
                    }

                }
                .sub-heading{
                  font-size: 14px;
                  font-weight: 400;
                  text-align: center;
                  margin-top: 3%;
                  line-height: 130%;
                  width: 100%;
                  color: @ibe-text--dark-gray;

                    &.in-slider{
                        font-size: 14px;
                        font-weight: 400;
                        text-align: center;
                        line-height: 120%;
                    }

                }
              }
            }

            .greyBackground{
                height:300px;
                &.in-slider{
                    height: 342px;
                }
            }
        }
    }
</style>
